import React from "react";

import { styled } from "@mui/material/styles";

export const TagStyles = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  width: "fit-content",
  borderRadius: 4,
  backgroundColor: "#E6EEF6",
  padding: "4px 8px",
}));

export const TagValue = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: 12,
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: 0.5,
  color: "#004D95",
}));

interface ITag {
  value: string;
}

export default function Tag({ value }: ITag) {
  return (
    <TagStyles>
      <TagValue>{value}</TagValue>
    </TagStyles>
  );
}
